<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12">
    <div class="card card-stats">
      <div class="card-header text-center">ELETRONORTE</div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-12">
            <div class="text-dark">
              <p>
                {{ descricao }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
